// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "owa." + "styles" + ".p." + "d66022b0" + ".css";
};